import { ReactNode, useState } from "react";
import { DropdownMenu } from "radix-ui";
import ChevronDownIcon from "../icons/ChevronDownIcon";

export const DropdownRoot = (props: {
  children: React.ReactNode;
  className?: string;
}) => {
  const { children, className } = props;
  const [open, setOpen] = useState(false);
  return (
    <DropdownMenu.Root
      modal={false}
      open={open}
      onOpenChange={(open) => setOpen(open)}
    >
      <div
        className={`c-dropdown-default ${className ?? ""}${
          open ? " is-showing" : ""
        }`}
      >
        {children}
      </div>
    </DropdownMenu.Root>
  );
};

export const DropdownTrigger = (props: {
  children?: ReactNode;
  className?: string;
  disabled?: boolean;
}) => {
  const { children, className, disabled } = props;

  return (
    <DropdownMenu.Trigger
      className={`c-dropdown-default-trigger ${className ?? ""}`}
      disabled={disabled}
      // asChild={true}
    >
      {children}
      <ChevronDownIcon width={20} />
    </DropdownMenu.Trigger>
  );
};

export const DropdownContent = (props: {
  children?: ReactNode;
  className?: string;
}) => {
  const { children, className } = props;

  return (
    <DropdownMenu.Content
      className={className ?? "c-dropdown-default-content"}
      align={"start"}
    >
      {children}
    </DropdownMenu.Content>
  );
};

export const DropdownItem = (props: {
  children: ReactNode;
  asChild?: boolean;
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
}) => {
  const { children, asChild, className, disabled, onClick } = props;

  return (
    <DropdownMenu.Item
      asChild={asChild}
      className={`c-dropdown-default-item ${className ?? ""}`}
      onClick={onClick}
      disabled={disabled}
      style={{ cursor: "pointer" }}
    >
      {children}
    </DropdownMenu.Item>
  );
};

export const DropdownItemIcon = (props: { children: ReactNode }) => {
  const { children } = props;

  return <span className="c-dropdown-default-item-icon">{children}</span>;
};

export const DropdownSeparator = () => {
  return <DropdownMenu.Separator className="c-dropdown-default-separator" />;
};
